

export enum EndPoints {
  Login = 'Authenticate/Login',
  MfaSend = 'Mfa/Send',
  MfaVerify = 'Mfa/Verify',
  ForgotPassword = 'Authenticate/ForgotPassword',
  ResetPassword = 'Authenticate/ResetPassword',
  ChangePassword = 'Authenticate/ChangePassword',
  QBOClass = 'OneTimeSync/QBOClass',
  LogOut = 'Authenticate/LogOut',
  ValidateToken = 'Authenticate/GetValidateToken',
  PayBevAutoLogin = 'Authenticate/SsoLogin',
  ValidateSsoToken = 'Authenticate/ValidateToken',

  //roles
  AddRole = 'Role/CreateRole',
  UpdateRole = 'Role/UpdateRole',
  GetRoleById = 'Role/GetRoleById',
  GetAllRoles = 'Role/GetRoleList',
  DeleteRole = 'Role/DeleteRole',
  UpdatePermissions = 'Role/UpdatePremission',
  UpdateEmailDefaults = 'Role/UpdateEmailDefaults',

  GetRoles = 'Role/roles',

  GetRoleDropdownList = 'User/GetRoles',

  uploadFile = 'Generic/UploadFile',
  deleteFile = 'Generic/DeleteFile',
  uploadContractFile = 'Account/UploadContract',

  GetTransactionCount = 'Transactions/GetTransactionCount',
  UpdateTransactionIsSeen = 'Transactions/UpdateTransactionIsSeen',
  UpdateBadgeTransaction = 'Badges/UpdateBadgeTransaction',

  //User
  AddUser = 'User/CreateUser',
  EditUser = 'User/UpdateUser',
  GetUsers = 'User/GetRecords',
  GetUserDetailsById = 'User/GetRecordById',
  GetUserAccounts = 'User/GetUserAccounts',
  GetPaybevUserDetails = 'User/GetPaybevUserDetails',
  UpdateProfileData = 'User/ProfileUpdate',
  UpdateUserProfile = 'User/UpdateUserProfile',
  UploadProfilePicture = 'User/ProfilePicture',
  ReInviteUser = 'User/ReInviteUser',
  ExportUsers = 'User/ExportUsers',
  GetAllUserEmails = 'User/GetAllUserEmails',
  GetSupplierUserFilters = 'User/GetSupplierUserFilters',

  //agency
  getAllAgency = 'Agency/GetAgencyRecords',
  AddAgency = 'Agency/AddAgency',
  UpdateAgency = 'Agency/UpdateAgency',
  DeleteAgency = 'Agency/DeleteRecord',
  GetAgencyDropdown = 'Agency/GetAgencyDropdown',
  GetAgencyDropdownList = 'Agency/GetAgencyDropdownList',

  //account
  getAllAccounts = 'Account/GetAccountRecords',
  AddAccount = 'Account/AddAccount',
  UpdateAccount = 'Account/UpdateAccount',
  GetAccountsByAgency = 'Account/GetAccountsByAgency',
  GetAccountSitesByAgency = 'Account/GetAccountSitesByAgency',
  GetAmDirectorUsers = 'Account/GetAmDirectorUsers',
  GetAccountDropdownList = 'Account/GetAccountDropdownList',
  GetAllAccountTypes = 'Account/GetTypeRecords',
  AddAccountType = 'Account/AddAccountType',
  DeleteAccount = 'Account/DeleteRecord',
  GetAccountDependencies = 'Account/GetDependencies',
  UpdateAccountType = 'Account/UpdateAccountType',
  DeleteAccountType = 'Account/DeleteAccountType',
  GetAllAccountTypesDropdown = 'Account/GetAllAccountTypes',
  GetInternalUsersDropdown = 'Account/GetInternalUsersDropdown',
  ExportAccounts = 'Account/ExportAccounts',
  GetAccountTypesForFilter = 'Account/GetAccountTypesForFilter',
  GetAssignmentsForFilter = 'Account/GetAssignmentsForFilter',

  //resources
  GetResourceRecords = 'PayBevResource/GetResourceRecords',
  AddResource = 'PayBevResource/AddResource',
  UpdateResource = 'PayBevResource/UpdateResource',
  DeleteResource = 'PayBevResource/DeleteResource',
  UpdateResourceOrderNo = 'PayBevResource/UpdateOrderNo',

  //sites

  getAllSites = 'Sites/GetSitesRecords',
  AddSite = 'Sites/AddSite',
  UpdateSite = 'Sites/UpdateSite',
  GetSiteByAccount = 'Sites/GetSite',
  GetAllFilters = 'Sites/GetAllFilters',
  ExportSites = 'Sites/ExportSites',
  GetAccountDropdownListByAgencyType = 'Sites/GetAccountDropdownListByAgencyType',
  GetAllSiteTypesDropdown = 'Sites/GetSiteTypeForFilter',
  NonAlcTransactionsExport = 'Sites/NonAlcTransactionsExport',
  GetNonAlcTransactionFilters = 'Sites/GetNonAlcTransactionFilters',

  //Programm
  GetAllPrograms = 'Program/GetAll',
  AddProgram = 'Program/Add',
  UpdateProgram = 'Program/Update',
  DeleteProgram = 'Program/Delete',
  makeProgramDefault = 'Program/UpdateDefault',
  UpdateProgramVisible = 'Program/UpdateVisible',

  //tags
  GetAllTags = 'Tag/GetAll',
  AddTagGroup = 'Tag/Add',
  UpdateTagGroup = 'Tag/Update',
  DeleteTagGroup = 'Tag/Delete',
  AddTag = 'Tag/AddTag',
  UpdateTag = 'Tag/UpdateTag',
  DeleteTag = 'Tag/DeleteTag',

  //investors and partners
  getAllPPartners = 'Investors/GetRecords',
  AddPPartner = 'Investors/AddInvestor',
  DeletePPartner = 'Investors/DeleteInvestor',
  GetDBPartner = 'Investors/SearchInDatabase',
  AddPartnerFromDB = 'Investors/AddInvestorFromDatabase',
  GetRepsName = 'Investors/GetRepsName',
  GetUnmappedQboSuppliers = 'Investors/GetUnmappedQboSuppliers',
  UpdateSupplierDetails = 'Investors/UpdateSupplierDetails',
  GetInvestorForSite = 'Investors/GetInvestorForSite',
  MapRetailSupplierToQboCustomer = 'Investors/MapRetailSupplierToQboSupplier',

  //vendors
  AddVendors = 'Vendor/AddVendor',
  GetAllVendors = 'Vendor/GetRecords',
  DeletePVendors = 'Vendor/DeleteVendor',
  AddVendorFromDB = 'Vendor/AddVendorFromDatabase',
  GetDBVendors = 'Vendor/SearchInDatabase',
  UpdateVendorStatus = 'Vendor/UpdateVendorStatus',
  GetAllVendorsRecords = 'Vendor/GetVendors',
  GetVendor = 'Vendor/GetVendor',
  GetSiteVendor = 'Vendor/GetSiteVendor',

  //get records for site from QBO such as Class, terms, product/serviecs and categories
  GenericPopulateRecords = 'Generic/GetPopulateRecords',

  //genetric

  //sites
  GetNonAlcTransaction = 'Sites/GetNonAlcTransaction',
  GetSiteNonAlcBalance = 'Sites/GetSiteNonAlcBalance',
  UpdateNonAlcDetails = 'Sites/UpdateNonAlcDetails',
  DeleteSite = 'Sites/DeleteSite',
  GetSiteDependencies = 'Sites/GetDependencies',

  //Suppliers
  GetSupplierById = 'Reps/GetRepSupplierById',

  //Reps
  getAllSupplier = 'Reps/GetSupplierRecords',
  getAllReps = 'Reps/GetRepsRecords',
  UpdateInvoiceStatus = 'Reps/UpdateInvoiceStatus',
  UpdateRepsProfile = 'Reps/UpdateProfile',
  UpdateSupplierStatus = 'Reps/UpdateSupplierStatus',
  UpdateSupplierNonAlcStatus = 'Reps/UpdateSupplierNonAlcStatus',
  // UpdateSupplierDetails = 'Reps/UpdateSupplierDetails',

  //users
  DeleteUser = 'User/DeleteRecord',
  UniqueUser = 'User/userexists',
  getSpecificUserDetails = 'User/get',
  GetPermissionModules = 'Role/module',
  GetPermissionsByRole = 'Role/getpermissionbyrole',

  //refunds
  GetRefundsList = 'Refunds/GetRefundInvestments',
  GetRefundsById = 'Refunds/GetRefundsById',
  UpdateRefund = 'Refunds/UpdateRefunds',
  GetRefundInvestments = 'Refunds/GetRefundInvestments',

  //investors
  GetInvestorBySiteId = 'Investors/GetInvestorBySite',
  GetInvestorDetails = 'Investors/GetInvestorDetails',
  GetInvestorDetailsQBO = 'Investors/GetInvestor',
  GetInvestorBYQboId = 'Investors/GetInvestorBYQboId',
  GetInvestorAndSiteDetails = 'Investors/GetInvestorAndSiteDetails',
  GetAllSuppliersDropdown = 'Investors/GetAllSuppliersDropdown',
  getUnlinkedSuppliers = 'Investors/GetUnmappedSuppliers',

  //investments
  MapWithExistingCustomer = 'Investments/MapWithExistingCustomer',
  UpdateInvestment = 'Investments/UpdateInvestment',
  ApproveInvestment = 'Investments/ApproveInvestment',
  SaveInvestment = 'Investments/SaveInvestment',
  SetInvestmentBalanceTransferFlag = 'Investments/SetInvestmentBalanceTransferFlag',
  ScheduleInvestment = 'Investments/BrooklynInvestment',
  GetProgramBySite = 'Program/GetProgrameBySite',
  DeleteInvestment = 'Investments/DeleteInvestment',
  GetInvestmentDescription = 'Investments/GetInvestmentDescription',
  UpdateInvestmentDescription = 'Investments/UpdateInvestmentDescription',
  GetEstimateAndInvoices = 'Investments/GetEstimateAndInvoices',
  GetUnderReviews = 'Investments/GetUnderReviews',
  ExportUnderReviews = 'Investments/ExportUnderReviews',

  GetInvestment = 'Investments/GetInvestment',
  AddNewCustomer = 'Investments/AddNewCustomer',
  GetSuppliersList = 'Investments/GetSuppliersList',

  GetEstimates = 'Investments/GetInvestments',
  GetEstimateAndInvoicesFilters = 'Investments/GetEstimateAndInvoicesFilters',
  GetFutureInvestmentsFilters = 'Investments/GetFutureInvestmentsFilters',
  ReviewInvestment = 'Investments/ReviewInvestment',

  GetEmailInvestmentDetails = 'Investments/GetEmailInvestmentDetails',
  SendInvestmentIssueEmail = 'Investments/SendInvestmentIssueEmail',

  GetEmailPaymentDetails = 'Payments/GetEmailPaymentsDetails',
  GetEmailExpenseDetails = 'Payments/GetEmailExpensesDetails',

  SendPaymentExpensesIssueEmail = 'Payments/SendPaymentExpensesIssueEmail',

  //investments futures
  GetFutures = 'Investments/GetFutureInvestments',
  ExportToExcelFutures = 'Investments/ExportFutureInvestments',
  ExportToExcelEstimatesInvoices = 'Investments/ExportEstimateAndInvoices',
  ExportToExcelRefunds = 'Refunds/ExportRefundInvestments',
  GetRefundInvestmentsFilters = 'Refunds/GetRefundInvestmentsFilters',

  GetUserSites = 'User/GetUserSites',
  GetSiteDetailsById = 'Sites/GetSiteDetailsById',
  GetAllSiteTypes = 'Sites/GetAllSiteTypes',

  // payments
  getAllBills = 'Payments/GetPayments',
  GetPayment = 'Payments/GetPayment',
  MapWithExistingVendor = 'Payments/MapWithExistingVendor',
  UnlinkVendor = 'Payments/UnlinkVendor',
  GetQBOVendorDropdownList = 'Vendor/GetQBOVendorDropdownList',
  AddNewVendor = 'Payments/AddNewVendor',
  GetSiteVendorDropdownList = 'Vendor/GetSiteVendorDropdownList',
  CreateBill = 'Payments/CreateBill',
  UpdatePayment = 'Payments/UpdatePayment',
  BillApprove = 'Payments/BillApprove',
  DeletePayment = 'Payments/DeletePayment',
  GetTagsDropdownlist = 'Tag/GetTagsDropdownlist',
  PreviewQBOAttachment = 'Payments/PreviewQBOAttachment',
  UploadW9AttachmentFile = 'Payments/UploadW9AttachmentFile',
  PaybevBillAttachment = 'Payments/PaybevBillAttachment',
  UpdateQBOVendor = 'Payments/UpdateQBOVendor',

  //Bills
  GetBills = 'Payments/GetBills',
  GetBillsFilters = 'Payments/GetBillsFilters',
  ExportBills = 'Payments/ExportBills',
  GetExpensesV2 = 'Payments/GetExpensesV2',
  GetExpensesFilters = 'Payments/GetExpensesFilters',
  ExportExpense = 'Payments/ExportExpense',
  GetUnderReviewPayments = 'Payments/GetUnderReviewPayments',
  ExportUnderReviewPayments = 'Payments/ExportUnderReviewPayments',

  //EXPENSE
  GetExpenses = 'Payments/GetExpenses',
  GetExpenseDetail = 'Payments/GetExpense',
  UpdateExpense = 'Payments/UpdateExpense',
  DeleteExpense = 'Payments/DeleteExpense',

  //Deposits
  GetDeposits = 'Deposits/GetDeposits',
  GetDepositsV2 = 'Deposits/GetDepositsV2',
  GetDepositsFilters = 'Deposits/GetDepositsFilters',
  ExportDeposits = 'Deposits/GetDepositsExport',
  GetDepositDetail = 'Deposits/GetDepositsById',
  UpdateDeposit = 'Deposits/UpdateDeposits',

  //Credit
  GetCredits = 'Credits/GetCredits',
  GetCreditsV2 = 'Credits/GetCreditsV2',
  GetCreditsFilters = 'Credits/GetCreditsFilters',
  ExportCredits = 'Credits/ExportCredits',
  GetCreditDetail = 'Credits/GetCreditsById',
  UpdateCredit = 'Credits/UpdateCredits',

  //Internal Transfer
  GetInternalTransferDetails = 'Transfers/GetInternalTransfer',
  GetInternalTransfersFilters = 'Transfers/GetInternalTransfersFilters',
  ExportInternalTransfers = 'Transfers/ExportInternalTransfers',
  GetInternalTransfersV2 = 'Transfers/GetInternalTransfersV2',
  GetInternalTransfers = 'Transfers/GetInternalTransfers',
  UpdateInternalTransfer = 'Transfers/UpdateInternalTransfer',

  //Overview
  GetOverviewData = 'Dashboard/GetOverviewData',
  GetSiteOverviewData = 'Dashboard/GetSiteOverviewData',
  GetFavoriteSiteOverviewData = 'Dashboard/GetFavoriteSiteOverviewData',
  FavoriteSite = 'Dashboard/FavoriteSite',
  UnFavoriteSite = 'Dashboard/UnFavoriteSite',
  GetOverviewChartData = 'Dashboard/GetOverviewChartData',
  GetCashFlow = 'Dashboard/GetCashFlow',
  SaveInvestmentLiabilities = 'Dashboard/SaveInvestmentLiabilities',
  GetInvestmentLiabilitie = 'Dashboard/GetInvestmentLiabilitie',
  getAccountByAgency = 'Account/GetAccountByAgency',
  GetSiteByAccountDropdownList = 'Sites/GetSiteByAccountDropdownList',
  GetSiteByAccountDropdown = 'Sites/GetSiteByAccountDropdown',

  //Reports
  GetSiteDetailReport = 'Reports/SiteDetail',
  HistoricalReports = 'Reports/HistoricalReports',
  ExportToExcelReports = 'Reports/BrooklynSummaryReport',

  //maintenance
  GetMaintenance = 'Sites/GetAllMaintainance',
  AddOrUpdateMaintenance = 'Sites/AddOrUpdateMaintainance',

  //announcements
  GetAllAnnouncements = 'Sites/GetAllAnnouncement',
  InactiveOrDeleteAnnouncement = 'Sites/InactiveOrDeleteAnnouncement',
  AddOrUpdateAnnouncement = 'Sites/AddOrUpdateAnnouncement',

  //Retail Programs
  GetAllRetailPrograms = 'RetailProgram/GetRetailProgram',
  AddRetailProgram = 'RetailProgram/AddRetailProgram',
  UpdateRetailProgram = 'RetailProgram/UpdateRetailProgram',
  UpdateRetailProgramEmailDefaults = 'RetailProgram/UpdateRetailProgramEmailDefaults',
  DeleteRetailProgram = 'RetailProgram/DeleteRetailProgram',
  GetRetailProgramById = 'RetailProgram/GetRetailProgramById',
  GetRetailProgramBannerAndLogo = 'RetailProgram/GetBannerAndLogo',
  GetRetailProgramGetRetailProgramForCheckBox = 'RetailProgram/GetRetailProgramForCheckBox',
  GetRetailProgramGetPreviewBrandsWithProducts = 'RetailProgram/GetPreviewBrandsWithProducts',
  GetAllOperatorSites = 'Sites/GetAllOperatorSites',

  //badges
  GetAllBadges = 'Badges/GetRecords',
  GetAllBadgesRecords = 'Badges/GetAllRecords',
  AddOrUpdateBadge = 'Badges/AddOrUpdateBadges',
  DeleteBadge = 'Badges/DeleteBadges',
  UpdateOrderNo = 'Badges/UpdateOrderNo',
  GetAllInvestmentBadges = 'Badges/GetAllInvestmentBadges',
  GetAllPaymentBadges = 'Badges/GetAllPaymentBadges',

  // UnderReview APIs
  GetAllUnderReview = 'UnderReview/GetAll',
  GetAllInvestmentUnderReview = 'UnderReview/GetAllInvestmentUnderReview',
  GetAllPaymentUnderReview = 'UnderReview/GetAllPaymentUnderReview',
  GetUnderReviewById = 'UnderReview',
  DeleteUnderReview = 'UnderReview',
  CreateUnderReview = 'UnderReview/CreateUnderReview',
  UpdateUnderReview = 'UnderReview/UpdateUnderReview',
  UpdateUnderReviewOrderNo = 'UnderReview/UpdateOrderNo',
  UpdateTransactionUnderReview = 'UnderReview/UpdateTransactionUnderReview',

  // Terms APIs
  GetAllTerms = 'Terms/GetAll',
  GetTermsById = 'Terms/GetById',
  GetNextTermsVersion = 'Terms/NextVersion',
  AddTerms = 'Terms/Add',
  UpdateTerms = 'Terms/Update',

  //resync data
  ResyncPaymentData = 'Payments/RefreshPayment',
  ResyncExpenseData = 'Payments/RefreshExpense',
  ResyncDepositData = 'Deposits/RefreshDeposit',
  ResyncCreditData = 'Credits/RefreshCredit',
  ResyncInternalTransferData = 'Transfers/RefreshInternalTransfer',
  ResyncInvestmentData = 'Investments/RefreshInvestment',
  ResyncRefundData = 'Refunds/RefreshRefund',
  ResyncQBOTransactions = 'Sites/ResyncQBOTransactions',

  //Retail (code added by Dev)
  GetRetailProgramForCheckBox = 'RetailProgram/GetRetailProgramForCheckBox',
  GetRetailSupplierCodes = 'RetailProgram/GetRetailSupplierCodes',

  //Reps
  ExportSuppliers = 'Reps/ExportSuppliers',
  ExportReps = 'Reps/ExportReps',

  //Projections
  GetProjectionGoalGrid = 'Projection/GetGoalGrid',
  GetProjectionGridFilters = 'Projection/GetGridFilters',
  UpdateProjectionGoal = 'Projection/UpdateGoal',
  ExportProjectionGoalGrid = 'Projection/ExportGoalGrid',
  GetProjectionForecastGrid = 'Projection/GetForecastGrid',
  UpdateProjectionForecast = 'Projection/UpdateForecast',
  CheckProjectionCyPyNeedsSync = 'Projection/CheckCyPyNeedsSync',
  SyncProjectionCyPy = 'Projection/SyncCyPy',
  GetProjectionSyncCyPyStatus = 'Projection/SyncCyPyStatus',
  ExportProjectionForecastGrid = 'Projection/ExportForecastGrid',
  InvestmentProjectionsExport = 'Reports/InvestmentProjectionsExport',
}

export const AuthEndpoints = {
  LoginStart: 'Authenticate/login/start',
  LoginPassword: 'Authenticate/login/password',
  Refresh: 'Authenticate/Refresh',
  ResetPassword: 'Authenticate/ResetPassword',
  // Security > Password: emails the signed-in caller their own reset link. Takes no body — the
  // account and the portal both come from the JWT.
  SendPasswordResetLink: 'Authenticate/password/reset-link',
  // Terms sign-off: the last gate of a sign-in. Anonymous — the caller holds a terms token, not a JWT.
  TermsPending: 'TermsAcceptance/Pending',
  // Security > Terms: the caller's own agreement plus the published policies.
  MyAgreements: 'TermsAcceptance/MyAgreements',
  MyAgreement: 'TermsAcceptance/MyAgreement',
  PolicyPdf: 'TermsAcceptance/Policy',
  // Users grid > Last Agreement: another user's signed agreement, for admins only.
  UserAgreementPdf: 'UserAgreement',
  TermsAccept: 'TermsAcceptance/Accept',
  TermsPolicy: 'TermsAcceptance/Policy',
  MfaSend: 'Mfa/Send',
  MfaVerify: 'Mfa/Verify',
  MfaPhoneSend: 'Mfa/phone/send',
  MfaPhoneVerify: 'Mfa/phone/verify',
  // My Profile: a new mobile number only replaces the old one once a code texted to it is verified.
  PhoneChangeSend: 'PhoneChange/send',
  PhoneChangeResend: 'PhoneChange/resend',
  PhoneChangeVerify: 'PhoneChange/verify',
  PasskeyRegisterOptions: 'Passkey/register/options',
  PasskeyRegisterComplete: 'Passkey/register/complete',
  PasskeyLoginOptions: 'Passkey/login/options',
  PasskeyLoginComplete: 'Passkey/login/complete',
  PasskeyList: 'Passkey/list',
  PasskeyRevoke: 'Passkey',
  PasskeySnooze: 'Passkey/prompt/snooze',
  DeviceList: 'Device/list',
  DeviceRevoke: 'Device',
  ActivationStatus: 'Activation/status',
  ActivationVerifyIdentity: 'Activation/verify-identity',
  ActivationVerifyPhone: 'Activation/verify-phone',
  ActivationVerifyEmail: 'Activation/verify-email',
  ActivationResend: 'Activation/resend',
  ActivationSetPassword: 'Activation/set-password',
  ActivationPasskeyOptions: 'Activation/passkey/options',
  ActivationPasskeyComplete: 'Activation/passkey/complete',
  SsoHandoff: 'Authenticate/sso/handoff',
} as const;
